import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@crm/ui';
import { Palette } from 'lucide-react';
import { PageHeader } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { ThemeSelector } from '../components/theme-selector';

export function AppearancePage() {
  useDocumentTitle('Aparencia');

  return (
    <div className="space-y-6">
      <PageHeader
        icon={<Palette />}
        title="Aparencia"
        description="Escolha como o CRM e exibido neste navegador."
      />

      <Card variant="flush" className="max-w-xl">
        <CardHeader>
          <CardTitle className="text-base">Tema</CardTitle>
          <CardDescription>
            A preferencia fica salva neste navegador; sem escolha, seguimos o tema do sistema.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ThemeSelector />
        </CardContent>
      </Card>
    </div>
  );
}
